import { useCallback } from "react";
import { Button } from "@/components/buttons/Button";
import ExternalLinkIcon from "@/common/images/icons/external-link.svg?react";
import OnlyFansIcon from "./images/onlyfans.svg?react";
import "./AdCreator.scss";

export interface IAdCreator {
  image: string;
  name: string;
  link: string;
  ctaText?: string;
  handleClick?: () => void;
}

export const AdCreator = ({
  image,
  name,
  link,
  ctaText = "Visit Page",
  handleClick
}: IAdCreator) => {
  const onClick = useCallback(() => {
    handleClick?.();
    window.open(link, "_blank");
  }, [link, handleClick]);

  return (
    <div className="AdCreator">
      <div className="creatorImage">
        <img src={image} alt={name} />
        <OnlyFansIcon className="badgeIcon" />
      </div>
      <div className="creatorTitleWrapper">
        <span className="creatorTitle">{name}</span>
        <Button className="creatorLink" fullWidth onClick={onClick} size="s" variant="secondary">{ctaText} <ExternalLinkIcon /></Button>
      </div>
    </div>
  );
};
